import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Icons } from '../../../shared/helpers/icons';
import { LucideAngularModule } from 'lucide-angular';

@Component({
  selector: 'function-details',
  standalone: true,
  imports: [
    CommonModule,
    LucideAngularModule
  ],
  templateUrl: './function-details.component.html',
  styleUrl: './function-details.component.css'
})
export class FunctionDetailsComponent {

  icons = Icons;

  @Input() functionDetails: any | null = null;;

  @Output() onClose = new EventEmitter<void>;

  closeModal(): void {
    this.onClose.emit();
  }
}
